{
  "common.actions.buscar": {
    "defaultMessage": "Rechercher"
  },
  "common.actions.close": {
    "defaultMessage": "Close"
  },
  "common.actions.createEntity": {
    "defaultMessage": "common.actions.createEntity"
  },
  "common.actions.edit": {
    "defaultMessage": "common.actions.edit"
  },
  "common.actions.select": {
    "defaultMessage": "Select..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Select all"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Select none"
  },
  "common.actions.share": {
    "defaultMessage": "Share"
  },
  "common.actions.view": {
    "defaultMessage": "View"
  },
  "common.apiError.body": {
    "defaultMessage": "Please try again in a few seconds. {br} Contact us if the error persists."
  },
  "common.apiError.title": {
    "defaultMessage": "The server seems unresponsive"
  },
  "common.confirmationModal.cancelBtnText": {
    "defaultMessage": "Cancel"
  },
  "common.confirmationModal.confirmBtnText": {
    "defaultMessage": "Confirm"
  },
  "common.copyBtn.copied": {
    "defaultMessage": "Copied"
  },
  "common.fatalError.body": {
    "defaultMessage": "Essayez de revenir à l'accueil. Si le problème continue, reconnectez-vous ou contactez-nous."
  },
  "common.fatalError.loginAgainBtn": {
    "defaultMessage": "Se connecter"
  },
  "common.fatalError.refreshBtn": {
    "defaultMessage": "Aller à l'accueil"
  },
  "common.fatalError.title": {
    "defaultMessage": "Une erreur s'est produite"
  },
  "common.fileInput.btnText": {
    "defaultMessage": "Select files"
  },
  "common.form.cancelBtnText": {
    "defaultMessage": "Cancel"
  },
  "common.form.dateRange.endDatePlaceholder": {
    "defaultMessage": "End date"
  },
  "common.form.dateRange.startDatePlaceholder": {
    "defaultMessage": "Start date"
  },
  "common.form.errorNotification": {
    "defaultMessage": "An error ocurred. {br} Please check all fields and try again"
  },
  "common.form.exitCancelBtnText": {
    "defaultMessage": "Keed editing"
  },
  "common.form.exitConfirmBtnText": {
    "defaultMessage": "Cancel without saving"
  },
  "common.form.exitPrompt": {
    "defaultMessage": "Do you want to cancel? {br} Unsaved changes will be lost."
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Save"
  },
  "common.form.savedBtnText": {
    "defaultMessage": "Saved"
  },
  "common.form.updateBtnText": {
    "defaultMessage": "Update"
  },
  "common.form.updatedBtnText": {
    "defaultMessage": "Updated"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Idioma"
  },
  "common.listFilter.apply": {
    "defaultMessage": "Search"
  },
  "common.listFilter.reset": {
    "defaultMessage": "Reset"
  },
  "common.noResults": {
    "defaultMessage": "common.noResults"
  },
  "common.pagination.countText": {
    "defaultMessage": "Showing {showCount, plural, =0 {no items} one {# item} other {# items} } of {totalCount}"
  },
  "common.reset": {
    "defaultMessage": "Reset"
  },
  "common.text.clear": {
    "defaultMessage": "Clear"
  },
  "common.timezoneSelect.defaultLabel": {
    "defaultMessage": "Timezone"
  },
  "common.viewError.actions.back": {
    "defaultMessage": "Retour"
  },
  "common.viewError.actions.home": {
    "defaultMessage": "Aller à l'accueil"
  },
  "common.viewError.actions.retry": {
    "defaultMessage": "Réessayer"
  },
  "common.viewError.details.toggle": {
    "defaultMessage": "Détails techniques"
  },
  "common.viewError.error.help": {
    "defaultMessage": "Réessayez. Si le problème persiste, contactez-nous."
  },
  "common.viewError.error.title": {
    "defaultMessage": "Nous n'avons pas pu charger ces informations"
  },
  "common.viewError.forbidden.help": {
    "defaultMessage": "Si vous pensez devoir y avoir accès, demandez-le à un administrateur."
  },
  "common.viewError.forbidden.title": {
    "defaultMessage": "Vous n'avez pas la permission de voir ceci"
  },
  "common.viewError.notFound.help": {
    "defaultMessage": "L'élément n'existe pas ou a été supprimé. Vérifiez le lien ou revenez à la liste."
  },
  "common.viewError.notFound.title": {
    "defaultMessage": "Nous n'avons pas trouvé ce que vous cherchiez"
  },
  "common.viewError.unavailable.help": {
    "defaultMessage": "Vérifiez votre connexion et réessayez dans quelques instants."
  },
  "common.viewError.unavailable.title": {
    "defaultMessage": "Connexion impossible"
  },
  "stream.thumbnails.empty": {
    "defaultMessage": "No hay miniaturas disponibles"
  },
  "stream.thumbnails.loading": {
    "defaultMessage": "Cargando miniaturas"
  }
}
